import React from 'react';

import SkeletonLoader from '@components/SkeletonLoader';

import { useListAccountChildren } from 'generated/account.generated';

import AccountList from '../List';

interface ChildAccountsProps {
  /** ID of the account to display children for */
  account_id: string;
}

/** Child accounts list */
function ChildAccounts({ account_id }: ChildAccountsProps) {
  const { data, loading } = useListAccountChildren({
    variables: { input: { account_id } },
    skip: !account_id,
  });
  return (
    <SkeletonLoader height={300} loading={loading}>
      <AccountList
        data={data?.getAccountRecord.children ?? []}
        parent_id={account_id}
      />
    </SkeletonLoader>
  );
}

export { ChildAccounts };
